import React from 'react';
import { useMutation } from '@apollo/client';
import Notes from '../procedures/Notes';
import { deleteProcedureNote, postProcedureNote } from '../../../graph/surgeon/surgeries';
import { ProcedureEvent } from '../../../types/ProcedureEvent';

interface ProcedureNotesProps {
  procedureId: number;
  procedureNotes: Array<ProcedureEvent>;
}

const ProcedureNotes = ({ procedureId, procedureNotes }: ProcedureNotesProps) => {
  const [create] = useMutation(postProcedureNote);
  const [remove] = useMutation(deleteProcedureNote);

  const createNote = async (note: string) => {
    await create({
      variables: {
        id: procedureId,
        note: note,
      },
    });
  };

  const deleteNote = async (noteId: number) => {
    await remove({
      variables: {
        id: noteId,
      },
    });
  };

  return <Notes notes={procedureNotes} createNote={createNote} deleteNote={deleteNote} />;
};

export default ProcedureNotes;
